import {useStripeConnection} from 'organization/OrganizationSettings/StripeConnectionProvider'
import {FullPageLoader} from 'organization/theme/FullPageLoader'
import React from 'react'
import {useEffect} from 'react'
import {useLocation} from 'react-router'

export default function StripeConnectedCallbackHandler() {
  const location = useLocation()
  const {connected} = useStripeConnection()
  const stripeAccountId = location.pathname.split('/')[5]

  useEffect(() => {
    connected(stripeAccountId)
  }, [connected, stripeAccountId])

  return <FullPageLoader />
}
